import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from '@angular/http';
import { Response } from '@angular/http';
import { DatePipe } from '@angular/common';
import 'rxjs/add/operator/map';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Users } from '../models/users';
import { Role } from 'app/models/role';
import { UpdatePassword } from 'app/models/request/updatePassword';

@Injectable()
export class UserService {
  private url = `/api/users`;

  constructor(private http: HttpClient) {}

  public find(): Observable<[Users]> {
    const params = new HttpParams()
      .set("size", "page")
      .set("size", "50")
      .set("sortName", "id")
      .set("sortType", "DESC");
    return this.http.get<[Users]>(this.url, { params: params });
  }

  create(user: Users) {
    return this.http.post(this.url, user).map(data => {
      console.log(data);
    });
  }

  updatePassword(item: UpdatePassword) {
    console.log("service update");

    return this.http.post(this.url+'/password', item).map(data => {
      console.log(data);
    },(erreur)=>{ console.error(erreur);
    });
  }

  delete(user: Users) {
    return this.http.delete(`${this.url}/${user.id}`).map(data => {
      console.log(data);
    });
  }

  update(user: Users) {
    return this.http.put(`${this.url}/${user.id}`, user).map(data => {
      console.log('update de  ', data);
    });
  }

  getRoles(): Observable<[Role]> {
    return this.http.get<[Role]>(`${this.url}/roles`);
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/user.service.ts